module.exports = __webpack_public_path__ + "img/postcards.4a771b73.png";